import { React, useEffect, useState, useRef } from 'react';

import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from '@mui/material';

import { Alerta } from '../../components/alerta';
import { fetchFlask } from '../../utils/fetchFlask';
import { formatCurrency } from '../../utils/stringFormat';
import { maskCpfCnpj } from '../../utils/maskCpfCnpj';

const AprovarSerasa = () => {
    const [cadastro, setCadastro] = useState('');
    const [listaCadastros, setListaCadastros] = useState('');
    const [aprovado, setAprovado] = useState(false);
    const [relatorio, setRelatorio] = useState('');
    const [message, setMessage] = useState('');
    const [status, setStatus] = useState('');
    const [openAlerta, setOpenAlerta] = useState(false);

    const hasFetched = useRef(false);

    useEffect(() => {
        if (hasFetched.current) return;
        hasFetched.current = true;

        async function buscarCadastrosAmarelos() {
            const response = await fetchFlask('buscarSerasaAmarelo');
            if (response.status !== 'error') {
                setListaCadastros(response.doc_list);
            } else {
                setMessage(response.message);
                setStatus(response.status);
                setOpenAlerta(true);
            }
        }

        buscarCadastrosAmarelos();
    }, []);

    useEffect(() => {
        if (cadastro) {
            getSerasaReport();
        }
    }, [cadastro]);

    async function getSerasaReport() {
        const body = JSON.stringify({
            document: cadastro
        });

        const response = await fetchFlask('buscarRelatorioSerasa', body);

        if (response.status === 'success') {
            setRelatorio(response.content);
        } else {
            setMessage(response.message);
            setStatus(response.status);
            setOpenAlerta(true);
        }
    }

    async function submitApproveSerasa(e) {
        e.preventDefault();

        const body = JSON.stringify({
            approved: aprovado,
            document: cadastro
        });

        const response = await fetchFlask('avaliarDocumentoSerasa', body);
        setMessage(response.message);
        setStatus(response.status);
        setOpenAlerta(true);

        if (response.status === 'success') {
            setCadastro('');
            setListaCadastros('');
            setRelatorio('');
            setAprovado(false);
        }
    }

    return (
        <Box className="mainBox">
            <Alerta
                texto={message}
                status={status}
                open={openAlerta}
                handleClose={() => setOpenAlerta(false)}
            />

            <Grid container alignItems="center" justifyContent="center" marginBottom={2} spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="h3">Aprovar Serasa</Typography>
                </Grid>

                <Grid item xs={8}>
                    <form action="" method="POST" id="formSerasaApproval" onSubmit={submitApproveSerasa}>
                        <Grid item xs={12}>
                            <Box display="flex" justifyContent="center" mt={2}>
                                <FormControl sx={{ display: 'flex' }}>
                                    <Autocomplete
                                        sx={{ width: '300px' }}
                                        value={cadastro}
                                        options={listaCadastros}
                                        getOptionLabel={(option) => maskCpfCnpj(option)}
                                        onChange={(e, value) => setCadastro(value)}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Cadastro Serasa"
                                                required
                                                value={maskCpfCnpj(cadastro)}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Box>
                        </Grid>

                        {relatorio && (
                            <>
                                <Grid item xs={12}>
                                    <TableContainer component={Paper} sx={{ margin: 'auto', mt: 4 }}>
                                        <Typography variant="h6" sx={{ p: 2 }}>
                                            Relatório Serasa
                                        </Typography>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell><strong>Credor</strong></TableCell>
                                                    <TableCell><strong>UF</strong></TableCell>
                                                    <TableCell><strong>Natureza</strong></TableCell>
                                                    <TableCell><strong>Dívida (R$)</strong></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {relatorio.flat().map((row, idx) => (
                                                    <TableRow key={idx}>
                                                        <TableCell>{row.creditorName}</TableCell>
                                                        <TableCell>{row.federalUnit}</TableCell>
                                                        <TableCell>{row.legalNature}</TableCell>
                                                        <TableCell>{formatCurrency(row.amount)}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>

                                <Grid container justifyContent="center" spacing={2} marginTop={2}>
                                    <Grid item>
                                        <Button
                                            onClick={() => setAprovado(true)}
                                            type="submit"
                                            variant="contained"
                                            sx={{
                                                backgroundColor: 'green',
                                                color: 'white',
                                                '&:hover': { backgroundColor: 'darkgreen' }
                                            }}
                                        >
                                            Aprovar Cadastro
                                        </Button>
                                    </Grid>
                                    <Grid item>
                                        <Button
                                            onClick={() => setAprovado(false)}
                                            type="submit"
                                            variant="contained"
                                            sx={{
                                                backgroundColor: 'red',
                                                color: 'white',
                                                '&:hover': { backgroundColor: 'darkred' }
                                            }}
                                        >
                                            Reprovar Cadastro
                                        </Button>
                                    </Grid>
                                </Grid>
                            </>
                        )}
                    </form>
                </Grid>
            </Grid>
        </Box>
    );
};

export default AprovarSerasa;
